import {
  put,
  fork,
  delay,
} from 'redux-saga/effects';


import {
  bettingSuggestionsResetToInitialState,
  bettingSuggestionsInitialWaitOver,
} from 'actions/components';
import {
  BS_INITIAL_WAIT_TIME,
} from 'constants/app';


function* waitOver() {
  yield delay(BS_INITIAL_WAIT_TIME);
  yield put(bettingSuggestionsInitialWaitOver());
}

function* watchBettingSuggestions() {
  yield put(bettingSuggestionsResetToInitialState());
  yield fork(waitOver); // don't show betting suggestion right after changing match
}

export default watchBettingSuggestions;
